module.exports = __webpack_public_path__ + "static/media/Hamster.da93114c.gif";